import type { Organization } from '@hotjar/organization';
import type { UseQueryResult } from 'react-query';
import { useCurrentSiteProp } from '@hotjar/site';
import type { Site } from '@hotjar/site';

const selector = (site: Site | undefined): Organization | undefined => site?.organization;

export const useCurrentOrganization = (): UseQueryResult<Organization | undefined, Error> => {
  return useCurrentSiteProp<Organization | undefined>(selector);
};
